/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react';
import { Layout, Row, Col } from 'antd';
import FeatherIcon from 'feather-icons-react';
import { NavLink, Link } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { connect } from 'react-redux';
import propTypes from 'prop-types';
import { Div, SmallScreenAuthInfo, SmallScreenSearch } from './style';
import HeaderSearch from '../components/header-search/header-search';
import AuthInfo from '../components/utilities/auth-info/info';
import { changeRtlMode, changeLayoutMode, changeMenuMode } from '../redux/themeLayout/actionCreator';
import logo_url from '../static/img/mark_cal_logo.png';

const { darkTheme } = require('../config/theme/themeVariables');

const { Header, Footer, Sider, Content } = Layout;

const ThemeLayout = WrappedComponent => {
  class LayoutComponent extends Component {
    constructor(props) {
      super(props);
      this.state = {
        // collapsed: false,
        hide: true,
        searchHide: true,
      };
      this.updateDimensions = this.updateDimensions.bind(this);
    }

    componentDidMount() {
      window.addEventListener('resize', this.updateDimensions);
      this.updateDimensions();
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.updateDimensions);
    }

    updateDimensions() {
      this.setState({
        // collapsed: window.innerWidth <= 1200 && true,
      });
    }

    render() {
      const { hide, searchHide } = this.state;
      const { ChangeLayoutMode, rtl, topMenu } = this.props;
      const left = !rtl ? 'left' : 'right';
      const darkMode = ChangeLayoutMode;

      const SideBarStyle = {
        margin: '63px 0 0 0',
        padding: '15px 15px 55px 15px',
        overflowY: 'auto',
        height: '100vh',
        position: 'fixed',
        [left]: 0,
        zIndex: 998,
        display: 'none',
      };

      return (
        <Div darkMode={darkMode}>
          <Layout className="layout scheduling-app-layout">
            <Header className="scheduling-header">
              <Row align="middle" gutter={16}>
                <Col lg={8} sm={12} xs={14} className="align-center-v navbar-brand">
                  <Link to="/" className="scheduling-brand">
                    {/* <span className="scheduling-brand__icon" aria-hidden="true">
                      <FeatherIcon icon="calendar" size={22} />
                    </span>
                    <span className="scheduling-brand__text">
                      <span className="scheduling-brand__name">Mark Your Cal</span>
                      <span className="scheduling-brand__tagline">Find a time. Pick a place. Get together.</span>
                    </span> */}
                    <img  width={190} height={60} src={logo_url} ></img>
                  </Link>
                </Col>

                <Col lg={10} md={0} sm={0} xs={0} className="scheduling-header__center">
                  {/* <span className="scheduling-security-badge">
                    <FeatherIcon icon="shield" size={14} />
                    Secure &amp; encrypted
                  </span> */}
                </Col>

                {/* <Col lg={6} md={0} sm={0} xs={0} className="scheduling-header__auth">
                  <AuthInfo rtl={rtl} className="desktop-menu-item" />
                </Col> */}
              </Row>
            </Header>

            <div className="header-more">
              <Row>
                <Col md={0} sm={24} xs={24}>
                  <div className="small-screen-headerRight">
                    <SmallScreenSearch hide={searchHide} darkMode={darkMode}>
                      <HeaderSearch rtl={rtl} />
                    </SmallScreenSearch>
                    <SmallScreenAuthInfo hide={hide} darkMode={darkMode}>
                      <AuthInfo rtl={rtl} className="mobile-menu-item" />
                    </SmallScreenAuthInfo>
                  </div>
                </Col>
              </Row>
            </div>

            <Layout>
              {!topMenu || window.innerWidth <= 991 ? (
                <ThemeProvider theme={darkTheme}>
                  <Sider width={280} style={SideBarStyle} collapsed theme={!darkMode ? 'light' : 'dark'} />
                </ThemeProvider>
              ) : null}
              <Layout className="atbd-main-layout menu-footer-adjuest">
                <Content className="scheduling-content">
                  <WrappedComponent {...this.props} />
                </Content>
              </Layout>
            </Layout>

            <Footer className="admin-footer scheduling-footer">
              <Row>
                <Col sm={12} md={24} lg={12} xs={24}>
                  <span className="admin-footer__copyright">
                    {new Date().getFullYear()} &copy; Mark Your Cal &mdash; Scheduling for distributed teams
                  </span>
                </Col>
                <Col sm={12} md={24} lg={12} xs={24}>
                  <div className="admin-footer__links">
                    <NavLink to="/calendar">Calendar</NavLink>
                    <NavLink to="/view-events">My Events/Matches</NavLink>
                    <NavLink to="/guide">Guide</NavLink>
                    <NavLink to="/about">About</NavLink>
                    <NavLink to="/contact-us">Contact</NavLink>
                    <NavLink to="/privacy-policy">Privacy</NavLink>
                    <NavLink to="/terms-and-conditions">Terms</NavLink>
                    {/* <NavLink to="/fbSignIn">Sign In</NavLink> */}
                  </div>
                </Col>
              </Row>
            </Footer>
          </Layout>
        </Div>
      );
    }
  }

  const mapStateToProps = state => ({
    ChangeLayoutMode: state.ChangeLayoutMode.data,
    rtl: state.ChangeLayoutMode.rtlData,
    topMenu: state.ChangeLayoutMode.topMenu,
  });

  const mapStateToDispatch = dispatch => ({
    changeRtl: rtl => dispatch(changeRtlMode(rtl)),
    changeLayout: show => dispatch(changeLayoutMode(show)),
    changeMenuMode: show => dispatch(changeMenuMode(show)),
  });

  LayoutComponent.propTypes = {
    ChangeLayoutMode: propTypes.bool,
    rtl: propTypes.bool,
    topMenu: propTypes.bool,
    changeRtl: propTypes.func,
    changeLayout: propTypes.func,
    changeMenuMode: propTypes.func,
  };

  return connect(mapStateToProps, mapStateToDispatch)(LayoutComponent);
};

export default ThemeLayout;